import { MouseEvent } from "react"

export const Tab = ({
  label,
  handleClick,
  isSelected,
}: {
  label: string
  handleClick: (event: MouseEvent) => void
  isSelected: boolean
}) => (
  <div className="relative">
    <button
      onClick={handleClick}
      className={`relative h-12 px-2 text-xs font-semibold uppercase tracking-wider text-black focus:outline-none focus:ring focus:ring-brand-green sm:text-sm md:px-4 lg:text-base ${
        isSelected ? "bg-brand-green-dark text-white focus:ring-transparent" : "bg-transparent"
      }`}
    >
      {label}
    </button>
    {isSelected && (
      <div className="bottom-triangle absolute -bottom-[calc(3rem-1px)] h-12 w-full bg-brand-green-dark" />
    )}
  </div>
)
